import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 451E9683-F30C-4B0A-95EE-5AD92B012F26
 * name subtitles-outline
 * version: 2.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/subtitles-outline.svg
 * tags
 */
export const SubtitlesOutlineIcon = createSvgIcon(<><path d="M20,4A2,2 0 0,1 22,6V18A2,2 0 0,1 20,20H4A2,2 0 0,1 2,18V6A2,2 0 0,1 4,4H20M20,18V6H4V18H20M6,10H8V12H6V10M6,14H14V16H6V14M16,14H18V16H16V14M10,10H18V12H10V10Z" /></>, 'SubtitlesOutlineIcon');
export default SubtitlesOutlineIcon